import * as globals from "./globals";
export { globals };



// WEBPACK FOOTER //
// ./src/config/index.js